import { useGetProfileUserInfo } from '../../../../../hooks/useGetProfileUserInfo'
import Button from '../../../../../components/Button'
import { useTranslation } from 'react-i18next'
import { useHutritClubUploadTalentStore } from '../../globalStore'
import Tooltip from '../../../../../components/Tooltip'

const SuccessView = () => {
  const { setIsEditVideo } = useHutritClubUploadTalentStore()
  const { t } = useTranslation()

  const { data: userData = {}, isLoading: userDataIsLoading } =
    useGetProfileUserInfo()

  const { userInfo = {} } = userData

  if (userDataIsLoading) return <div>CARGANDO...</div>

  return (
    <div className="d-flex flex-column align-items-center mt-4 w-100 px-lg-0 px-2">
      <h2 className="text-on-bg-primary text-center fw-bold mb-4">
        ¡Reto entregado!
      </h2>
      <div className="px120 py-4 d-flex flex-column align-items-center border border-2 rounded w-100 bg-bg-secondary">
        <div className="d-flex flex-column align-items-center gap-4 mt-2">
          <div className="d-flex flex-column align-items-center gap-2 rounded shadow-sm w-100 px-2 py-3">
            <div className="text-on-bg-primary text-center fw-bold fontSize14">
              Descripción del reto
            </div>
            <div className="fontSize12 text-on-bg-secondary">
              {userInfo?.hutrit_next_videos?.[0]?.description}
            </div>
          </div>
          <video controls className="rounded" width={380} height={200}>
            <source
              src={userInfo?.hutrit_next_videos?.[0]?.url}
              type="video/mp4"
            />
            Tu navegador no soporta videos.
          </video>

          <Tooltip
            text={
              userInfo?.visible
                ? '¡Tu video fue aprobado con éxito! Ya forma parte de nuestra selección, por lo que no se puede editar.'
                : ''
            }
            renderTooltip={userInfo?.hutrit_next_videos?.[0]?.visible}
            style={{width: '400px'}}
          >
            <Button
              disabled={userInfo?.hutrit_next_videos?.[0]?.visible}
              onClick={() => {
                if (userInfo?.hutrit_next_videos?.[0]?.visible) return
                setIsEditVideo(true)
              }}
            >
              {t('edit_video')}
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default SuccessView
